import axios from 'axios';
import moment from 'moment';
import MitUnitsService from './MitUnitsService.js';

class MitStorageService {
  constructor() {

  }

  isDateTimeValid(dateTimeString){
    return (moment(dateTimeString, "YYYY-MM-DD HH:mm:ss", true).isValid() === true);
  }
  getDateNowStringLocal(){
    return moment().local().format('YYYY-MM-DD HH:mm:ss').toString();//default to now
  }
  getDateStringUtc(dateStringLocal){
    return moment(dateStringLocal, "YYYY-MM-DD HH:mm:ss").utc().format("YYYY-MM-DD HH:mm:ss").toString();
  }

  convertSize(items, propertyList){
      let unit = MitUnitsService.getUserVolumeUnit();
      let convertedValue = null;

      for(let x = 0; x < items.length; x++){
          items[x].sizeConverted = {
              unitId:unit.unit,
              unitName:unit.name
          };
          propertyList.forEach(property => {
              if(items[x].hasOwnProperty(property))
                convertedValue = (items[x][property] / unit.convert);
                if(convertedValue > 1000)
                    items[x].sizeConverted[property] = Math.floor(convertedValue);
                else if(convertedValue > 100)
                    items[x].sizeConverted[property] = convertedValue.toFixed(1);
                else if(convertedValue > 10)
                    items[x].sizeConverted[property] = convertedValue.toFixed(2);
                else
                    items[x].sizeConverted[property] = convertedValue.toFixed(3);
          });
      }

  }

  adaptAnalyticsToUIModel(volumes){
      this.convertSize(volumes,['sizeUsed']);
      for(let x = 0; x < volumes.length; x++){

        volumes[x].sizeGB = {
          sizeUsed: Math.floor(volumes[x].sizeUsed / 1000000000),
        };

      }

      return volumes;
  }

  adaptToUIModel(volumes){
    this.convertSize(volumes,['available', 'used', 'total', 'usedBySnapshots']);
    for(let x = 0; x < volumes.length; x++){

      volumes[x].dates_local = {
        createDt: moment(volumes[x].createDt).local().format('MM/DD/YYYY h:mm:ss a'),
        lastEditedDt: volumes[x].lastEditedDt != null ? moment(volumes[x].lastEditedDt).local().format('MM/DD/YYYY h:mm:ss a') : null
      };

      volumes[x].data_ui = JSON.stringify(volumes[x].data);
    }

    return volumes;
  }

  adaptVolumeDetailsToUIModel(volumes){
    this.convertSize(volumes,['available', 'used', 'total']);

    for(let x = 0; x < volumes.length; x++){
      volumes[x].dates_local = {
        createDt: moment(volumes[x].createDt).local().format('MM/DD/YYYY h:mm:ss a')
      };

    }

    return volumes;
  }
  adaptVolumeTreeToUIModel(node){
      let icon = 'mdi-harddisk'; //default for 'volumes'

      if(node.type === 'volumes')
        icon = 'mdi-server';
      else if(node.type === 'hosts')
        icon = 'mdi-server';
      else if(node.type === 'host')
        icon = 'mdi-server-network';
      else if(node.children.length > 0)
        icon = 'mdi-folder';

      node.ui = {
        icon: icon
      };

      for(let x = 0; x < node.children.length; x++){
          this.adaptVolumeTreeToUIModel(node.children[x]);
      }

      return node;
  }

  requestGetVolumes(paging, options) {
    return new Promise ((resolve, reject) => {

      let url = new URL(window.location.origin+'/api/v1/volumes');

      for (let prop in options) {
        if (options.hasOwnProperty(prop)) {
          url.searchParams.append(prop, options[prop]);
        }
      }
      for (let prop in paging) {
        if (paging.hasOwnProperty(prop)) {
          url.searchParams.append(prop, paging[prop]);
        }
      }

      axios.get(url.pathname+url.search)
        .then((response) => {
            this.adaptToUIModel(response.data.volumes);
            return resolve(response.data);
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }

  requestGetLeafVolumes(options) {
    return new Promise ((resolve, reject) => {

      let url = new URL(window.location.origin+'/api/v1/volumes/leaf');

      for (let prop in options) {
        if (options.hasOwnProperty(prop) && options[prop] !== null) {
          url.searchParams.append(prop, options[prop]);
        }
      }

      axios.get(url.pathname+url.search)
        .then((response) => {
            this.adaptToUIModel(response.data.volumes);
            return resolve(response.data);
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }

  requestGetVolumesExploreGrouped() {
      return new Promise ((resolve, reject) => {

        axios.get('/api/v1/volumes/tree/grouped')
          .then((response) => {
              for(let x = 0; x < response.data.tree.length; x++)
                this.adaptVolumeTreeToUIModel(response.data.tree[x])

              return resolve(response.data);
          })
          .catch((error) => {
            if(error.response)
              return reject(error.response.data);

            return reject(error);
          });

      });
  }
  requestGetVolumesExplore(grouped) {
      return new Promise ((resolve, reject) => {

        let url = '/api/v1/volumes/tree/host';
        if(grouped){
            url = '/api/v1/volumes/tree/grouped'
        }
        axios.get(url)
          .then((response) => {
              for(let x = 0; x < response.data.tree.length; x++)
                this.adaptVolumeTreeToUIModel(response.data.tree[x])

              return resolve(response.data);
          })
          .catch((error) => {
            if(error.response)
              return reject(error.response.data);

            return reject(error);
          });

      });
  }
  requestGetVolumeDetails(volumeId) {
    return new Promise ((resolve, reject)=> {

      axios.get('/api/v1/volume/'+volumeId)
        .then((response) => {
            this.adaptVolumeDetailsToUIModel(response.data.records);
            return resolve(response.data);
        })
        .catch((error) => {
          if(error.response)
            return reject(error.response.data);

          return reject(error);
        });

    });
  }

  requestGetVolumesAnalyticsActivity(options) {
    return new Promise ((resolve, reject)=> {
        let url = new URL(window.location.origin+'/api/v1/volumes/analytics/top_activity');

        for (let prop in options) {
          if (options.hasOwnProperty(prop) && options[prop] !== null) {
            url.searchParams.append(prop, options[prop]);
          }
        }

        axios.get(url.pathname+url.search)
            .then((response) => {
                this.adaptAnalyticsToUIModel(response.data.analytics);
                return resolve(response.data);
            })
            .catch((error) => {
              if(error.response)
                return reject(error.response.data);

              return reject(error);
            });

        });
    }
    requestGetVolumesAnalyticsTopUsers(options) {
      return new Promise ((resolve, reject)=> {
          let url = new URL(window.location.origin+'/api/v1/volumes/analytics/top_users');

          for (let prop in options) {
            if (options.hasOwnProperty(prop) && options[prop] !== null) {
              url.searchParams.append(prop, options[prop]);
            }
          }

          axios.get(url.pathname+url.search)
              .then((response) => {
                  this.adaptAnalyticsToUIModel(response.data.analytics);
                  return resolve(response.data);
              })
              .catch((error) => {
                if(error.response)
                  return reject(error.response.data);

                return reject(error);
              });

      });
    }
    requestGetVolumesAnalyticsTimeSeries(options) {
      return new Promise ((resolve, reject)=> {
          let url = new URL(window.location.origin+'/api/v1/volumes/analytics/timeseries');

          for (let prop in options) {
            if (options.hasOwnProperty(prop) && options[prop] !== null) {
              url.searchParams.append(prop, options[prop]);
            }
          }

          axios.get(url.pathname+url.search)
              .then((response) => {
                  for(let x = 0; x < response.data.volumes.length; x++){
                      for(let y = 0; y < response.data.volumes[x].length; y++){
                          response.data.volumes[x][y].datesLocal = {
                            createDt: new moment(response.data.volumes[x][y].createDt).local()//.format('MM/DD/YYYY h:mm:ss a')
                          };
                          this.convertSize(response.data.volumes[x],['used','available','total' ]);
                      }
                  }
                  return resolve(response.data);
              })
              .catch((error) => {
                if(error.response)
                  return reject(error.response.data);

                return reject(error);
              });

      });
    }


}

export default new MitStorageService();
